import logo from '../assets/logo.png';

const FALLBACK_BRAND_FONT = '"Space Grotesk", "IBM Plex Sans", "Helvetica Neue", Arial, sans-serif';

export const LOGO_URL = logo;
export const BRAND_FONT_FAMILY = process.env.REACT_APP_BRAND_FONT ?? FALLBACK_BRAND_FONT;
